import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { isCustomerSupport, isVideoRecorder } from '../utils/roles';
import Sessions from '../pages/Sessions';
import NewSession from '../pages/NewSession';

/** Block ticket-based roles from the legacy sessions list. */
export const SessionsListRoute: React.FC = () => {
  const { user } = useAuth();
  if (isCustomerSupport(user?.role)) {
    return <Navigate to="/tickets" replace />;
  }
  if (isVideoRecorder(user?.role)) {
    return <Navigate to="/my-tickets" replace />;
  }
  return <Sessions />;
};

/** Support never records; recorders must open recording with ?ticketId=. */
export const NewSessionRoute: React.FC = () => {
  const { user } = useAuth();
  const { search } = useLocation();
  const ticketId = new URLSearchParams(search).get('ticketId');

  if (isCustomerSupport(user?.role)) {
    return <Navigate to="/tickets" replace />;
  }
  if (isVideoRecorder(user?.role) && !ticketId) {
    return <Navigate to="/my-tickets" replace />;
  }
  return <NewSession />;
};
